import React from 'react';
import FormContact from '../partials/FormContact';
class Contact extends React.Component{

    render(){
        return(
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <h4 className="text-center">Solicite información</h4>
                    <p className="text-center">ó llámenos directamente al <strong>(01) 463-4070</strong></p>
                    <FormContact/>
                </div>
            </div>
        )
    }
}

export default Contact;
